import React, { useState } from "react";
import axios from "axios";
import { useToast } from "../components/ToastContext";

const ForgetPassword = () => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [status, setStatus] = useState(false);
  const showToast = useToast()

  const handleForgetPassSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start the loader

    try {
      const response = await axios.get(
        `${SERVER_URL}/students/forget-password/${email}`
      );
      setResponseMessage(response.data.message);
      setStatus(true);
      showToast()
    } catch (err) {
      const message = err.response?.data?.message || "An error occurred";
      setResponseMessage(message);
      setStatus(false);
     
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-8 md:mx-auto md:w-full md:max-w-md bg-white rounded-lg sm:mx-2">
      <div className="w-[100px] m-auto mb-4">
        <img
          src="/images/logo.svg"
          alt="Aifinite Learning"
          className="w-full"
        />
      </div>
      <div
        className="bg-[#fff] shadow-lg rounded-md py-8 px-4 md:rounded-lg md:px-10"
        style={{
          border: "1px solid #CACFD2",
          boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
        }}
      >
        <div className="flex justify-center">
          <p className="text-2xl font-bold">Forget Password</p>
        </div>
        <form className="flex flex-col gap-4" onSubmit={handleForgetPassSubmit}>
          <div className="relative w-full pt-2">
            <label className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <div className="mt-2">
              <input
                type="email"
                name="email"
                value={email}
                placeholder="Enter your email address"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500"
                required
              />
            </div>
          </div>

          <div className="relative w-full">
            <p className="text-gray-500 text-center text-xs">
              We will share a link to your email through which you will be able
              to reset your password.
            </p>
          </div>

          <div className="flex justify-center mt-4">
            <button
              type="submit"
              className={`w-full bg-blue-600 text-white rounded-md py-2 tracking-wide ${
                !email || email.length < 10 || loading
                  ? "opacity-50 cursor-not-allowed cursor-"
                  : ""
              }`}
              disabled={!email || email.length < 10 || loading}
            >
              {loading ? (
                <span className="loading loading-spinner loading-xs"></span>
              ) : (
                "SEND PASSWORD RESET LINK"
              )}
            </button>
          </div>

          {responseMessage && (
            <div
              className={`mt-2 text-center text-sm ${
                status ? "text-green-600" : "text-red-600"
              }`}
            >
              {responseMessage}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ForgetPassword;
